export const SESSION_TOKEN = "session-token";
export const TYPE_COMPONENT = "simple";
export const LINK_RULES_BAGGAGE = "https://www.voegol.com.br/informacoes/bagagem";
export const LINK_CHECKIN_FLIGHT = "https://b2c.voegol.com.br/check-in/";
export const MOBILE_SIZE = 769;
